import { inject, Injectable } from "@angular/core";
import { HttpService } from "../../../../abraj-shared/src/lib/services/http.service";
import { environment } from "../../environments/environment";
import { Permissions, PermissionsAPIResponse } from "../models/permissions.interface";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  permissions = new BehaviorSubject<Permissions | null>(null);
  private readonly httpService = inject(HttpService);
    private extractUserIdFromToken(token: string | null): string | null {
    if (!token) {
      console.error('No access token found in localStorage');
      return null;
    }
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      
      const decodedToken = JSON.parse(jsonPayload);
      const userId = decodedToken.sub || decodedToken.user_id || decodedToken.id || decodedToken.userId;
      
      if (!userId) {
        console.error('User ID not found in token payload');
        return null;
      }
      
      return userId;
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return null;
    }
    }

    fetchPermissions() {
      const accessToken = localStorage.getItem('access_token');
      const userId = this.extractUserIdFromToken(accessToken);
      return this.httpService
      .sendApiRequest<PermissionsAPIResponse>
      ("GET", environment.config.nafathMockUrl, `/api/User/${userId}/permissions`)
      .subscribe({
        next: (response) => {
          localStorage.setItem('organizationid', response.organizationid);
          localStorage.setItem('organizationtypeid', response.organizationtypeid);
          localStorage.setItem('requesttypeid', response.requesttypeid);
          localStorage.setItem('organizationtypename', response.organizationtypename);
          this.permissions.next(response.permissions);
        },
        error: (err) => {
          console.error('Error fetching permissions:', err);
        }
      });
    }

    getUserId(): string | null {
      const accessToken = localStorage.getItem('access_token');
      return this.extractUserIdFromToken(accessToken);
    }
}